import React from 'react';
import Lottie from 'lottie-react';

const ExternLinkCard = ({title, animation, url}) => {

    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full my-2 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center justify-center p-4 cursor-pointer"
            style={{ minHeight: '50px', maxHeight:'60px' }}
        >

            <div className="flex-shrink-0">
                <Lottie
                    animationData={animation}
                    style={{ width: 60, height: 60, marginLeft: -10 }}
                />
            </div>
            <div className="flex items-center flex-col text-white mr-4">
                <span className="text-sm font-extrabold text-[#e67e22] 00font-medium">
                    {title}
                </span>

            </div>
        </a>
    );
};

export default ExternLinkCard;